module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать город\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'city-details',
        params: {
          city_id: _vm.city.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям города")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.city.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteCity.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить город")]) : _vm._e()]), _vm._v(" "), _c('city-edit-form', {
    attrs: {
      "city": _vm.city
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bfc1617","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/city/CityEdit.vue
// module id = 667
// module chunks = 0